module.exports = __webpack_public_path__ + "img/logo.d713f58c.png";